import { Component, Input } from '@angular/core';
import { ProgressBarModule } from '@vg-constellation/angular-18/progress-bar';

import { CancelComponent } from '../cancel/cancel.component';

@Component({
  selector: 'app-progress-header',
  templateUrl: './progress-header.component.html',
  styleUrls: ['./progress-header.component.scss'],
  standalone: true,
  imports: [ProgressBarModule, CancelComponent],
})
export class ProgressHeaderComponent {
  @Input() value = 1;
  @Input() maxValue = 4;
  @Input() labelText = '';
  @Input() accountHat: string | null = null;
}
